<div class="p-grid table-demo manage-product-section">
    <div class="p-col-12">
        <div class="card  p-pt-3">
            <p-toast key="toastmsg"></p-toast>
            <div class="col-md-12 d-flex details-header">
                <div class="user-name">
                    <h3>Academy Payment Details</h3>
                </div>
            </div>
            
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton label="Clear All Filters" class="p-button-outlined p-mr-2 p-mb-2"
                        icon="pi pi-filter-slash" (click)="clear()
					"></button>
                    <!-- <button pButton pRipple label="Load User Wallet" icon="pi pi-plus"
                        class="p-button-success p-mr-2 p-mb-0" (click)="addNewWallet()"></button> -->
                </ng-template>
               
              
                <ng-template pTemplate="right">
                    <button pButton pRipple label="Export" icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-help mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                        
                </ng-template>
            </p-toolbar>
           
            <div class="card">
                <div class="p-fluid p-formgrid p-grid align-items-end">

                    <!-- <div class="p-field p-col-12 p-mb-0">
						<h5>Filter</h5>
					</div> -->
                    <div class="p-field p-col-2">
                        <label for="searchfield">Select Field</label>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            placeholder="Select Field" optionLabel="label"></p-dropdown>
                    </div>
                    <div class="p-field p-col-2">
                        <label for="startdt">Start Date</label>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true"></p-calendar>
                    </div>
                    <div class="p-field p-col-2">
                        <label for="enddt">End Date</label>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                            [(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
                            [showIcon]="true"></p-calendar>
                    </div>
                    <div class="p-field p-col-1">
                        <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-"
                            (click)="loadAcademyPaymentHistory(lastTableLazyLoadEvent)"></button>
                    </div>
                   
                </div>
            </div>


            <p-table class="p2-table-columns show-columns" #dt [value]="academypaymentlist" [paginator]="true" [rows]="10"
                [lazy]="true" (onLazyLoad)="loadAcademyPaymentHistory($event)" [totalRecords]="totalRecords" [loading]="loading"
                [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="id" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Transaction ID
                                <!-- <p-sortIcon field="id"></p-sortIcon> -->
                            </div>
                        </th>
                        <th pSortableColumn="academyName" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Academy Name
                                <!-- <p-sortIcon field="academyName"></p-sortIcon> -->
                            </div>
                        </th>
                        <!-- <th pSortableColumn="userEmail" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Email
                                <p-sortIcon field="userEmail"></p-sortIcon>
                            </div>
                        </th> -->
                       
                        <th pSortableColumn="mobileNumber" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Mobile
                                <!-- <p-sortIcon field="mobileNumber"></p-sortIcon> -->
                            </div>
                        </th>
                        <th pSortableColumn="paymentId" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Razorpay Payment Id
                                <!-- <p-sortIcon field="paymentId"></p-sortIcon> -->
                            </div>
                        </th>
                        <!-- <th pSortableColumn="description" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">Description</div>
                        </th> -->
                        <th pSortableColumn="amount" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Amount
                                <p-sortIcon field="amount"></p-sortIcon>
                            </div>
                        </th>
                        <th pSortableColumn="created_at" [style]="{'width':'120px'}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                Created Date
                                <p-sortIcon field="created_at"></p-sortIcon>
                            </div>
                        </th>
                        
                    </tr>
                    <tr>
                        <th [ngSwitch]="id">
                            <!-- <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'id', 'contains')"
                                [value]="dt.filters['id'] ? dt.filters['id'].value : ''" /> -->
                        </th>
                        <th [ngSwitch]="academyName">
                            <!-- <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                                [value]="dt.filters['academyName'] ? dt.filters['academyName'].value : ''" /> -->
                        </th>
                        <!-- <th [ngSwitch]="userEmail">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userEmail', 'contains')"
                                [value]="dt.filters['userEmail'] ? dt.filters['userEmail'].value : ''" />
                        </th> -->
                        <th [ngSwitch]="mobileNumber">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                                [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                        </th>
                        <th [ngSwitch]="paymentId">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'paymentId', 'contains')"
                                [value]="dt.filters['paymentId'] ? dt.filters['paymentId'].value : ''" />
                        </th>
                        
                        <!-- <th [ngSwitch]="description" class=""> -->
                            <!-- <p-dropdown appendTo="body" #pDropDownId [options]="description"
                              (onChange)="setDownloadFlag(); dt.filter($event.value, 'description', 'equals')" placeholder="Select Description"
                              [showClear]="true">
                              <ng-template let-option pTemplate="item">
                                <span [class]="'customer-badge description-' + option.value">{{option.label}}</span>
                              </ng-template>
                            </p-dropdown> -->
                          <!-- </th> -->
                        <th [ngSwitch]="amount" class="">
                            <input pInputText type="text"
                                (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amount', 'contains')"
                                [value]="dt.filters['amount'] ? dt.filters['amount'].value : ''" />
                        </th>
                        <th [ngSwitch]="created_at" class="">
                        </th>
                       
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-academypayment>
                    <tr class="p-selectable-row">
                        <td>
                            {{academypayment.id}}
                        </td>
                        <td>
                            {{academypayment.academyName}}
                        </td>
                        <!-- <td>
                            {{academypayment.email}}
                        </td> -->
                        <td>
                            {{academypayment.mobileNumber}}
                        </td>
                        <td>
                            {{academypayment.paymentId}}
                        </td>
                        <!-- <td>
                            {{userwallet.description}}
                        </td> -->
                        <!-- <td *ngIf="userwallet.coins!=0">                                    
                            <div class="debit" *ngIf="userwallet.action=='ADD'">
                                <i class='pi pi-plus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase }}<span></span>
                            </div>
                            <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                <i class='pi pi-minus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase}} <span></span>
                            </div>
                            
                        </td>
                        <td *ngIf="userwallet.cash!=0">
                            <div class="debit" *ngIf="userwallet.action=='ADD'">
                                <i class='pi pi-plus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}}<span></span>
                            </div>
                            <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                <i class='pi pi-minus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}} <span></span>
                            </div>
                        </td> -->
                        <td >
                            <i class=''></i> {{academypayment.amount}} 
                        </td>
                       
                        <td>
                            {{academypayment.created_at | date:'d/M/yyyy'}}
                        </td>
                        
                   
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">No Academy Payment Details.</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        In total there are {{totalRecords }} User Payment Details.
                    </div>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>